import { useContext } from 'react';
import { useStore } from 'zustand';
import { context } from '../context';
import type { DragHandlerState } from '../interfaces';

export const useDragHandlerStore = <T>(
  selector: (state: DragHandlerState) => T = (state) => state as T,
) => {
  const store = useContext(context);
  return useStore(store, selector);
};
